import { render, staticRenderFns } from "./UnitServiceOrderHistoryComponent.vue?vue&type=template&id=72dae0bf&"
import script from "./UnitServiceOrderHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./UnitServiceOrderHistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports